"use client";

import { LockBodyScroll } from "../LockBodyScroll";
import { LoadingSpinner } from "./LoadingSpinner";

export function LoadingOverlay({
  "data-testid": dataTestId,
}: {
  "data-testid"?: string;
}) {
  const baseTestId = dataTestId || "loading-overlay";
  return (
    <>
      <LockBodyScroll />
      <dialog
        data-testid={baseTestId}
        open
        className="fixed inset-0 z-[100] flex h-full w-full items-center justify-center"
      >
        <LoadingSpinner />
      </dialog>
    </>
  );
}
